<template>
	<div class="table__row table__row-entry">
		<div class="table__cell table__cell-entry">
			<h5>
				{{ file.original_name }} 
			</h5>
		</div>	
		
		<div class="table__cell table__cell-date">
			<p :title="file.added_on">
				{{ age }}
			</p>
		</div>

		<div class="table__cell-links">
            <small class="file-widget--file-size">{{ size }}&nbsp;</small>
			<ul>
				<li>
					Download:
					<a
						:href="file.download_permalink"
						class="download"
						target="_blank"
					>
						Local Network
					</a>
				</li>

				<li>
					<a
						:href="file.download_cdn_permalink"
						class="download"
						target="_blank"
					>
						CDN
					</a>
				</li>

				<li>
					<a :href="'#comment-' + file.comment_id" @click="handleClick" title="Go to comment">
						Open Message
					</a>
				</li>

				<template v-if="previewMain">
					<li>
						<a :href="previewMain" :data-lightbox="`widget-file-preview-${file['id']}`" target="_blank">Preview</a>
	
						<div v-if="previewPages && previewPages.length" class="hidden">
							<a v-for="(page, index) in previewPages" :href="page" :data-lightbox="`widget-file-preview-${file['id']}`" target="_blank">Page {{index + 1}}</a>
						</div>
					</li>
				</template>
			</ul>
		</div>
	</div>
</template>

<script>
/**
 * The external dependencies.
 */
import filesize from 'filesize';
import dayjs from 'dayjs';

import relativeTime from 'dayjs/plugin/relativeTime';
dayjs.extend(relativeTime)

export default {
	computed: {
		size() {
			const size = filesize(this.file.size, { output: "object" });
			let val = size.value;
			if (size.suffix === "KB" || size.suffix === "MB") {
				val = Math.round(val);
			}
			return val + ' ' + size.suffix;
		},

		age() {
			return dayjs(this.file.added_on).fromNow(true);
		},

		preview() {
			return this.file.attachment_preview_url || this.previewMain;
		},

		previewMain() {
			if (!this.file.generated_previews || !this.file.generated_previews.length) {
				return null;
			}

			return this.file.generated_previews[0].preview_url;
		},

		previewPages() {
			if (!this.file.generated_previews || !this.file.generated_previews.length) {
				return null;
			}

			return this.file.generated_previews.slice(1).map(preview => preview.preview_url);
		},
	},

	props: {
		file: {
			required: true,
		}
	},

	methods: {
		handleClick() {
			document.body.classList.remove('sidebar-open');
		}
	},
};
</script>

<style>
.file-widget--file-size { font-size: 11px; float: right; line-height: 1; }
</style>
